{
  "firstName": "Prénom",
  "middleName": "Deuxième prénom",
  "lastName": "Nom de famille",
  "dateOfBirth": "Date de naissance",
  "primaryEmail": "Courriel",
  "phone": "Téléphone",
  "physicalAddress": "Adresse physique",
  "mailingAddress": "Adresse postale",
  "alternateAddress": "Adresse alternative",
  "inProvinceSince": "Dans la province depuis",
  "gender": "Genre",
  "language": "Langue",
  "maritalStatus": "État civil",
  "numberOfDependents": "Nombre de personnes à charge",
  "citizenships": "Citoyennetés",
  "countryOfTaxResidence": "Pays de résidence fiscale",
  "taxId": "Numéro d'identification fiscale",
  "taxIdType": "Type d'identification fiscale",
  "taxIdDisclosed": "Identification fiscale divulguée",
  "taxIdExists": "Identification fiscale existante",
  "sinExists": "NAS existant",
  "taxNumber": "Numéro fiscal",
  "spouseTaxId": "Identification fiscale du conjoint",
  "spouseTaxIdType": "Type d'identification fiscale du conjoint",
  "spouseTaxIdDisclosed": "Identification fiscale du conjoint divulguée",
  "employmentStatus": "Statut d'emploi",
  "jobTitle": "Titre du poste",
  "companyType": "Type d'entreprise",
  "employerName": "Nom de l'employeur",
  "employerCompanyAddress": "Adresse de l'employeur",
  "studentAreaOfStudy": "Domaine d'études",
  "employmentSituation": "Situation d'emploi",
  "employmentSituationOtherDescription": "Situation d'emploi (autre)",
  "annualIncomeCents": "Revenu annuel",
  "annualIncomeStr": "Revenu annuel",
  "financialLiquidAssetsCents": "Actifs liquides",
  "financialFixedAssetsCents": "Actifs immobilisés",
  "totalDebtCents": "Dette totale",
  "annualDebtPaymentsCents": "Paiements annuels de la dette",
  "sourceOfWealth": "Source de richesse",
  "sourceOfFunds": "Source de fonds",
  "sourceOfWealthOtherDescription": "Source de richesse (autre)",
  "sourceOfFundsOtherDescription": "Source de fonds (autre)",
  "debtAssociated": "Dette associée",
  "uniqueCircumstances": "Circonstances particulières",
  "spouseFirstName": "Prénom du conjoint",
  "spouseLastName": "Nom de famille du conjoint",
  "spouseAnnualIncomeCents": "Revenu annuel du conjoint",
  "trustedContactPerson": "Personne de confiance",
  "entityName": "Nom de l'entité",
  "typeOfTrust": "Type de fiducie",
  "establishedDate": "Date de constitution",
  "registrationNumber": "Numéro d'enregistrement",
  "countryOfRegistration": "Pays d'enregistrement",
  "investmentKnowledge": "Connaissances en placement",
  "riskQuestion1": "Question de risque 1",
  "riskQuestion2": "Question de risque 2",
  "foreignTaxInformation": "Renseignements fiscaux étrangers",
  "fatcaStatus": "Statut FATCA",
  "fatcaStatusOtherDescription": "Statut FATCA (autre)",
  "preferredMethodOfCommunication": "Mode de communication préféré",
  "iDCheckCompleted": "Vérification d'identité terminée",
  "iDCheckRetrigger": "Revérification d'identité",
  "iDVerified": "Identité vérifiée",
  "complianceState": "État de conformité",
  "payTaxesOutsideCanada": "Paie des impôts à l'extérieur du Canada"
}
